/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketTemplateDto } from '../../models/ticket-template-dto';
import { UpdateTicketTemplateDto } from '../../models/update-ticket-template-dto';

export interface TicketTemplateControllerUpdate$Params {
  id: string;
  centerId: string;
      body: UpdateTicketTemplateDto
}

export function ticketTemplateControllerUpdate(http: HttpClient, rootUrl: string, params: TicketTemplateControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, ticketTemplateControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketTemplateDto>;
    })
  );
}

ticketTemplateControllerUpdate.PATH = '/api/ticket/{centerId}/template/{id}';
